<template>
    <div class="brand-shops" ref="list" v-infinite-scroll="loadMore" infinite-scroll-disabled="canNotLoadMore" infinite-scroll-distance="10" infinite-scroll-immediate-check="true" style="-webkit-user-drag: none;">
        <p-header :title="name" :backRouteLocation="{name: 'shop', params: {id: shopId}, query: $route.query}"/>
        <div class="search">
            <img src="@/assets/img/search.png">
            <input type="text" placeholder="輸入您要的店名/路名" v-model="keyword" @input="search">
        </div>
        <div class="shop-list">
            <div class="item" v-for="shop in shops" @click="checkoutShop(shop)" :key="shop.id">
                <div class="name">
                    {{ shop.alias }}
                </div>
                <div class="district">
                    {{ shop.district }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Header from '../components/Header';
    import * as apis from '../../apis';
    import * as R from 'ramda';

    export default {
        name: 'BrandShops',
        components: {
            'p-header': Header,
        },
        data() {
            return {
                shopId: 0,
                name: '',
                logo: null,
                keyword: '',
                shops: [],
                page: {
                    total: 0,
                    current_page: 0,
                    last_page: 0,
                },
                searchTime: null,
                loading: false,
                latitude: 0,
                longitude: 0,
            };
        },
        computed: {
            canNotLoadMore() {
                return !(this.page.total && this.page.current_page < this.page.last_page && !this.loading);
            },
        },
        methods: {
            initBrand() {
                let payload = {
                    id: this.id,
                    params: {
                        'keyword': this.keyword,
                        latitude: this.latitude,
                        longitude: this.longitude,
                    }
                };
                apis.getBrandShops(payload).then(res => {
                    this.shops = res.data.data;
                    this.page = res.data.meta;
                    this.$nextTick(() => {
                        if (this.$refs.list.scrollHeight <= this.$refs.list.clientHeight) {
                            this.loadMore();
                        }
                    })
                });
            },
            checkoutShop(shop) {
                this.$router.replace({
                    name: 'shop',
                    params: {
                        id: shop.id
                    },
                    query: this.$route.query,
                })
            },
            search() {
                if (this.searchTime) {
                    clearTimeout(this.searchTime);
                }

                this.searchTime = setTimeout(() => {
                    let payload = {
                        id: this.id,
                        params: {
                            'keyword': this.keyword,
                            latitude: this.latitude,
                            longitude: this.longitude,
                        }
                    };
                    apis.getBrandShops(payload).then(res => {
                        this.shops = res.data.data;
                        this.page = res.data.meta;
                        this.$nextTick(() => {
                            if (this.$refs.list.scrollHeight <= this.$refs.list.clientHeight) {
                                this.loadMore();
                            }
                        })
                    });
                }, 500);
            },
            loadMore() {
                this.loading = true;
                let payload = {
                    id: this.id,
                    params: {
                        'keyword': this.keyword,
                        page: this.page.current_page + 1,
                        latitude: this.latitude,
                        longitude: this.longitude,
                    }
                };

                apis.getBrandShops(payload).then(res => {
                    this.shops = R.concat(this.shops, res.data.data);
                    this.page = res.data.meta;
                    this.loading = false;
                    this.$nextTick(() => {
                        if (this.$refs.list.scrollHeight <= this.$refs.list.clientHeight && this.page.current_page < this.page.last_page) {
                            this.loadMore();
                        }
                    })
                });
            }
        },
        created() {
            this.id = this.$route.params.id;
            this.shopId = this.$route.params.shopId;
            this.name = this.$route.params.name;
            this.logo = this.$route.params.logo;
            this.latitude = this.$route.query.latitude || 0;
            this.longitude = this.$route.query.longitude || 0;

            this.initBrand();
        }
    };
</script>

<style lang="scss" scoped>
    .brand-shops {
        min-height: var(--app-height);
    }

    .search {
        border-radius: 5px;
        background-color: #FFFFFF;
        box-shadow: 0 1px 5px 0 rgba(51,153,51,0.35);
        margin: 15px;
        padding: 10px;
        text-align: left;
        display: flex;
        align-items: center;

        img {
            height: 20px;
            width: 20px;
        }

        input {
            margin-left: 10px;
            border: none;
            flex: 1;
        }
    }

    .shop-list {
        margin: 15px;

        .item {
            display: flex;
            justify-content: space-between;
            padding: 10px 15px;
            border-radius: 5px;
            background-color: #FFFFFF;
            box-shadow: 0 0 3px 0 rgba(51,153,51,0.35);
            align-items: center;
            margin: 10px 0;

            .name {
                flex: 1;
                text-align: left;
                color: #000000;
                font-family: "PingFang TC";
                font-size: 14px;
                line-height: 20px;
            }

            .district {
                color: #787878;
                font-size: 12px;
                line-height: 17px;
                margin: 0 20px;
            }

            .score {
                display: flex;
                align-items: center;
                color: #339933;
                font-family: "PingFang TC";
                font-size: 14px;
                font-weight: 500;
                line-height: 20px;

                img {
                    width: 20px;
                    height: 20px;
                }
            }
        }
    }
</style>
